export const getClientEnvironment = () => {
  const hostname = typeof window !== 'undefined' ? window.location?.hostname ?? '' : ''
  if (hostname.includes('test.dfds-pax-web.com') || hostname === 'www.test.dfds.com') return 'test'
  if (hostname.includes('uat.dfds-pax-web.com') || hostname === 'www.accept.dfds.com') return 'uat'
  if (hostname.includes('uat-2.dfds-pax-web.com')) return 'uat-2'
  if (hostname.includes('uat-3.dfds-pax-web.com')) return 'uat-3'
  if (hostname.includes('uat-4.dfds-pax-web.com')) return 'uat-4'
  if (hostname.includes('dfds-pax-web.com') || hostname === 'www.dfds.com') return 'prod'
  return 'dev'
}
